module.exports = __webpack_public_path__ + "b4315b9adb236ab74e48319e6bec9629.jpg";